import React from "react";
import { observer } from "mobx-react";

import { useToggle } from "@formant/ui/utils/useToggle";

import { useStores } from "../../../context/StoreContext";
import { HotkeyBinding } from "./HotkeyBinding";
import { HotkeysHelp } from "./HotkeysHelp";
import { IHotkey } from "./IHotkey";

// Reads the IHotkeys defined in AppStore to:
// 1. Bind them via HotkeyBinding
// 2. Render HotkeysHelp popup
export const HotkeysBinding = observer(function HotkeysBinding() {
    const [help, { on: onShowHelp, off: onCloseHelp }] = useToggle(false);

    const { appStore } = useStores();

    // Wrap the hotkey handlers with a function that closes hotkey help.
    // Also add the Help hotkey.
    const hotkeys: IHotkey[] = [
        ...Array.from(appStore.hotkeys.values()).map(hotkey => {
            return {
                ...hotkey,
                onHotkey: (context: any) => {
                    onCloseHelp();
                    hotkey.onHotkey(context);
                },
            };
        }),
        {
            label: "Keyboard shortcuts",
            code: "shift+/",
            onHotkey: onShowHelp,
        },
    ];

    return (
        <div>
            {hotkeys
                .filter(_ => _.onHotkey)
                .map(hotkey => (
                    <HotkeyBinding key={hotkey.code} hotkey={hotkey} />
                ))}
            <HotkeysHelp
                hotkeys={hotkeys}
                visible={help}
                onClose={onCloseHelp}
            />
        </div>
    );
});
